import Vue from 'vue';

type State = {
  count: number;
};

const state = Vue.observable<State>({
  count: 0,
});

export default Vue.extend({
  name: 'PlbscfKeystrokeResetMixin',

  computed: {
    keystrokeResetCount(): number {
      return state.count;
    },
  },

  methods: {
    addKeystrokeResetCount(): void {
      state.count++;
    },
  },
});
